import type { ReactElement } from 'react';
import { cn } from '@/lib/cn';

export type LogoProps = {
  size?: number;
  className?: string;
};

export function Logo({ size = 24, className }: LogoProps): ReactElement {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden>
        <rect x="1" y="1" width="30" height="30" rx="7" fill="var(--ink)" />
        <path
          d="M10 9v14M10 9c2-1.5 6-1.5 8 0v14"
          stroke="var(--bg-page)"
          strokeWidth="1.75"
          strokeLinecap="round"
        />
        <circle cx="10" cy="22" r="2" fill="var(--bg-page)" />
        <circle cx="18" cy="22" r="2" fill="var(--warm)" />
      </svg>
      <span className="font-display text-[16px] font-semibold tracking-tight text-[var(--ink)]">
        Repertoire
      </span>
    </div>
  );
}
